import { useCallback, useReducer } from "react";
import type { BuilderSection } from "./types";

const EMPTY_SECTION_FLAGS: Record<BuilderSection, boolean> = {
  details: false,
  hardware: false,
  software: false,
  source: false,
  network: false,
  parameters: false,
};

interface SectionNavigationState {
  active: BuilderSection | null;
  departed: Record<BuilderSection, boolean>;
  advanced: Record<BuilderSection, boolean>;
}

type SectionNavigationAction = {
  type: "open";
  section: BuilderSection | null;
  countsAsAdvance: boolean;
};

const sectionNavigationReducer = (
  state: SectionNavigationState,
  action: SectionNavigationAction,
): SectionNavigationState => {
  if (action.section === state.active) return state;
  if (!state.active) return { ...state, active: action.section };

  return {
    active: action.section,
    departed: { ...state.departed, [state.active]: true },
    advanced: action.countsAsAdvance
      ? { ...state.advanced, [state.active]: true }
      : state.advanced,
  };
};

export const useSectionNavigation = (isEditMode: boolean) => {
  const [state, dispatch] = useReducer(sectionNavigationReducer, {
    active: isEditMode ? null : "details",
    departed: { ...EMPTY_SECTION_FLAGS },
    advanced: { ...EMPTY_SECTION_FLAGS },
  });
  const openSection = useCallback(
    (section: BuilderSection | null, countsAsAdvance = section !== null) => {
      dispatch({ type: "open", section, countsAsAdvance });
    },
    [],
  );
  return { ...state, openSection };
};
